import { COVERGO_SAAS_PROD } from "../consts.js"

export const icbl_uat = {
	"icbl-health-uat-studio.quote.hk": {
		appConfig: {
			tenantId: "icbl_uat",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_PROD
	}
}
